const numberCards = document.querySelectorAll('.number-card');

numberCards.forEach((numberCard) => {
  numberCard.addEventListener('click', () => {
    numberCard.classList.toggle('is-active');
  });
});
